// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carrusel-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 40px 20px;
}

.carrusel-column-wrapper {
  position: relative;
  width: 90%;
  max-width: 1000px;
  height: 500px;
  overflow: hidden;
  border: 8px solid #FF8C00;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  animation: floatCarrusel 3s ease-in-out infinite;
  transition: all 0.3s ease;
}

.carrusel-column-wrapper:hover {
  box-shadow: 0 15px 40px rgba(255, 140, 0, 0.3);
}

.carrusel-nav {
  background: #FF8C00;
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 2em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.carrusel-nav:hover {
  background: #5B4B8A;
  transform: scale(1.1);
}

.carrusel-nav:active {
  transform: scale(0.95);
}

@keyframes floatCarrusel {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-6px); }
}

.carrusel-column {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  transition: transform 0s;
}

.carrusel-column-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .carrusel-section {
    gap: 20px;
  }

  .carrusel-column-wrapper {
    height: 380px;
  }

  .carrusel-nav {
    width: 40px;
    height: 40px;
    font-size: 1.5em;
  }
}

@media (max-width: 480px) {
  .carrusel-section {
    gap: 15px;
  }

  .carrusel-column-wrapper {
    height: 250px;
    max-width: 100%;
  }

  .carrusel-nav {
    width: 35px;
    height: 35px;
    font-size: 1.2em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Carrusel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".carrusel-section {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 30px;\r\n  padding: 40px 20px;\r\n}\r\n\r\n.carrusel-column-wrapper {\r\n  position: relative;\r\n  width: 90%;\r\n  max-width: 1000px;\r\n  height: 500px;\r\n  overflow: hidden;\r\n  border: 8px solid #FF8C00;\r\n  border-radius: 20px;\r\n  box-shadow: 0 8px 16px rgba(0,0,0,0.2);\r\n  animation: floatCarrusel 3s ease-in-out infinite;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.carrusel-column-wrapper:hover {\r\n  box-shadow: 0 15px 40px rgba(255, 140, 0, 0.3);\r\n}\r\n\r\n.carrusel-nav {\r\n  background: #FF8C00;\r\n  color: white;\r\n  border: none;\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  font-size: 2em;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.carrusel-nav:hover {\r\n  background: #5B4B8A;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.carrusel-nav:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n@keyframes floatCarrusel {\r\n  0%, 100% { transform: translateY(0px); }\r\n  50% { transform: translateY(-6px); }\r\n}\r\n\r\n.carrusel-column {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  transition: transform 0s;\r\n}\r\n\r\n.carrusel-column-image {\r\n  height: 100%;\r\n  width: 100%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .carrusel-section {\r\n    gap: 20px;\r\n  }\r\n\r\n  .carrusel-column-wrapper {\r\n    height: 380px;\r\n  }\r\n\r\n  .carrusel-nav {\r\n    width: 40px;\r\n    height: 40px;\r\n    font-size: 1.5em;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .carrusel-section {\r\n    gap: 15px;\r\n  }\r\n\r\n  .carrusel-column-wrapper {\r\n    height: 250px;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .carrusel-nav {\r\n    width: 35px;\r\n    height: 35px;\r\n    font-size: 1.2em;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
